export enum UserRole {
  ADMIN = 'ADMIN',
  VOUCHER_MANAGER = 'VOUCHER_MANAGER'
}

export const ALL_ROLES = Object.values(UserRole);
